function parsePercent(value) {
  if (value === null) return 0;
  const n = parseFloat(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}

function atingeValorMinimoParaRecolhimento(valorTotalServico, valorMinimo) {
  if (!valorMinimo || !valorTotalServico) {
    return true;
  }

  const total = valorTotalServico ?? 0;
  return valorMinimo <= total;
}

export function sumRetencoesPercentuais(
  perfilPayload,
  simplesNacionalCliente,
  valorTotalServico
) {
  const profile = perfilPayload?.configuracaoNfse;
  if (!profile) return 0;

  const clienteOptanteSn = simplesNacionalCliente === "S";

  const retencoes = [
    {
      condicao: clienteOptanteSn ? !!profile.irrf?.retemSimplesNacional : true,
      aliquotas: [profile.irrf?.percentualAliquota],
      valorMinimoParaRecolhimento: profile.irrf?.valorMinimoParaRecolhimento,
    },
    {
      condicao: clienteOptanteSn ? !!profile.inss?.retemSimplesNacional : true,
      aliquotas: [profile.inss?.percentualAliquota],
      valorMinimoParaRecolhimento: profile.inss?.valorMinimoParaRecolhimento,
    },
    {
      condicao: !!profile.iss?.retido,
      aliquotas: [profile.iss?.percentualAliquota],
      valorMinimoParaRecolhimento: profile.iss?.valorMinimoParaRecolhimento,
    },
    {
      condicao: clienteOptanteSn
        ? !!profile.pisCofinsCsll?.retemSimplesNacional
        : true,
      aliquotas: [
        profile.pisCofinsCsll?.percentualAliquotaPis,
        profile.pisCofinsCsll?.percentualAliquotaCofins,
        profile.pisCofinsCsll?.percentualAliquotaCsll,
      ],
      valorMinimoParaRecolhimento:
        profile.pisCofinsCsll?.valorMinimoParaRecolhimento,
    },
  ];

  return retencoes.reduce((accTotal, item) => {
    if (!item.condicao) return accTotal;
    if (
      !atingeValorMinimoParaRecolhimento(
        valorTotalServico,
        item.valorMinimoParaRecolhimento
      )
    ) {
      return accTotal;
    }

    const somaAliquotas = item.aliquotas.reduce(
      (acc, curr) => acc + parsePercent(curr),
      0
    );
    return accTotal + somaAliquotas;
  }, 0);
}

export function calcValorRetencaoLinha(valueTotalNumber, percentualTotal) {
  if (!valueTotalNumber || !percentualTotal) {
    return 0;
  }
  return (valueTotalNumber * percentualTotal) / 100;
}
